import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import TimePicker from './TimePicker';
import './rc-time-picker/assets/index.scss';

const propTypes = {
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  handleClick: PropTypes.func,
  handleValueChange: PropTypes.func,
  defaultValue: PropTypes.shape({}),
  durationCalculate: PropTypes.shape({}),
  allowNextDay: PropTypes.bool,
  startFromDayBegin: PropTypes.bool,
  rest: PropTypes.shape({}),
  timeLimit: PropTypes.number,
  isDisableTime: PropTypes.bool,
  fromBookNowModal: PropTypes.bool,
  ariaLabel: PropTypes.string,
  isTimeValid: PropTypes.bool,
};

function TFVTimePickerV2({
  className = '',
  isDisabled = false,
  handleClick = () => {},
  handleValueChange = () => {},
  defaultValue = moment(),
  durationCalculate = moment(),
  allowNextDay = false,
  startFromDayBegin = false,
  timeLimit = 30,
  isDisableTime = false,
  fromBookNowModal = false,
  ariaLabel = '',
  isTimeValid = true,
  ...rest
}) {
  return (
    <TimePicker
      {...rest}
      defaultValue={defaultValue}
      durationCalculate={durationCalculate}
      showSecond={false}
      allowNextDay={allowNextDay}
      startFromDayBegin={startFromDayBegin}
      disabled={isDisabled}
      className={className}
      minuteStep={timeLimit}
      onChange={e => {
        handleValueChange(e);
      }}
      isDisableTime={isDisableTime}
      ariaLabel={ariaLabel}
      isTimeValid={isTimeValid}
    />
  );
}

TFVTimePickerV2.propTypes = propTypes;

export default TFVTimePickerV2;
